import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const Folders = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <View locale={locale === 'ru' ? 'ru' : 'en'}>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.folders.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.folders.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 67%;
  color: ${Colors.main_black};
  border-radius: 15.13px;
  background: ${(p) => `image-set(
        url('/images/mainpage/folders-bg-mob-${p.locale}.webp') type('image/webp'),
        url('/images/mainpage/folders-bg-mob-${p.locale}.png') type('image/png')
      )
      16px 100% / calc(100% - 32px) auto no-repeat,
    #f2e9e2`};

  @media ${Points.tablet_landscape} {
    padding: 30px 33px 208px 30px;
    background: ${(p) => `image-set(
          url('/images/mainpage/folders-bg-tab-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/folders-bg-tab-${p.locale}.png') type('image/png')
        )
        30px 100% / calc(100% - 62px) auto no-repeat,
      #f2e9e2`};
  }

  @media ${Points.laptop_wide} {
    padding: 40px 40px 60.33%;
    background: ${(p) => `image-set(
          url('/images/mainpage/folders-bg-lap-${p.locale}.webp') type('image/webp'),
          url('/images/mainpage/folders-bg-lap-${p.locale}.png') type('image/png')
        )
        40px 100% / calc(100% - 80px) auto no-repeat,
      #f2e9e2`};
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }
`;
